import { useMutation } from '@tanstack/react-query';

import { toast } from '@hivebrite/design-system/Toast';

import { createMentoringProfile } from 'hb-react/frontoffice/apps/Mentoring/requests';
import { type MenteeToMentorParams } from 'hb-react/frontoffice/apps/Mentoring/requests/types';
import { type Program } from 'hb-react/frontoffice/apps/Mentoring/types';
import { getProgramTopicId } from 'hb-react/frontoffice/apps/Mentoring/utils';

interface CreateMenteeToMentorProps {
  onSuccess?: () => void;
  program: Pick<Program, 'id' | 'parent_id' | 'parent_type'>;
}

export const useCreateMenteeToMentor = ({
  program,
  onSuccess,
}: CreateMenteeToMentorProps) => {
  const {
    id: programId,
    parent_id: parentId,
    parent_type: parentType,
  } = program;

  return useMutation({
    mutationFn: ({ applicationMessage, mentorId }: MenteeToMentorParams) =>
      createMentoringProfile({
        routeApi: Routes.mentorings_program_mentee_profiles_path(programId),
        payload: {
          mentee_profile: {
            application_message: applicationMessage,
            mentor_id: mentorId,
          },
        },
        topicId: getProgramTopicId({ parentId, parentType }),
      }),
    onSuccess,
    onError: (error) => {
      // @ts-expect-error untyped error
      if (error?.response?.status === 400) {
        toast.error(s__('Mentoring|You have already applied'));
      } else {
        toast.error(
          // @ts-expect-error untyped error
          error?.response?.data?.errors?.[0] || __('Sorry, an error occurred'),
        );
      }
    },
  });
};
